import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-fb",
  "use": "social-fb-usage",
  "viewBox": "0 0 10 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 20\" id=\"social-fb\">\n    <path d=\"M8.333 3.077c-1.335.105-1.694.654-1.666 1.538v2.308H10V10H6.667v10H2.5V10H0V6.923h2.5V4.615C2.672 1.728 3.994 0 7.5 0c.985 0 1.921.054 2.5 0v3.077\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol